import { parseCurrencyToNumber } from "../../utils/currency";
export function buildReclamationPayload(values, userId) {
    var _a, _b;
    return {
        userId: userId,
        category: values.category,
        description: values.description,
        involvedValue: parseCurrencyToNumber((_a = values.involvedValue) !== null && _a !== void 0 ? _a : ""),
        eventDate: (function () {
            if (!values.eventDate)
                return "";
            var d = new Date(values.eventDate);
            return isNaN(d.getTime()) ? "" : d.toISOString();
        })(),
        eventLocation: ((_b = values.eventLocation) === null || _b === void 0 ? void 0 : _b.trim()) || "Não informado",
        possibleSolution: values.possibleSolution,
        supplier: {
            name: values.companyName,
            cnpj: values.cnpj ? values.cnpj.replace(/\D/g, "") : undefined,
        },
    };
}
